import type { KeyboardEventHandler } from "react";

import { cn } from "../../utils";

/**
 * Chrome-less task title. Focusing it adds a caret, not a border — same
 * surface on create, edit, and the detail page so the field does not change
 * identity between those states.
 */
export function TaskTitleInput({
  value,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  readOnly,
  autoFocus,
  placeholder,
  className,
}: {
  value: string;
  onChange?: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  readOnly?: boolean;
  autoFocus?: boolean;
  placeholder?: string;
  className?: string;
}) {
  const locked = readOnly || !onChange;
  return (
    <input
      data-1p-ignore
      aria-label="Task title"
      value={value}
      readOnly={locked}
      autoFocus={autoFocus}
      placeholder={placeholder}
      onChange={(event) => onChange?.(event.target.value)}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      className={cn(
        "min-w-0 w-full rounded-md border-0 bg-transparent px-1 py-0.5",
        "text-2xl font-bold text-foreground shadow-none outline-none",
        "placeholder:font-semibold placeholder:text-muted-foreground",
        "focus-visible:border-0 focus-visible:ring-0",
        locked ? "pointer-events-none" : "cursor-text",
        className,
      )}
    />
  );
}
